"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const layers = {
    "base": "auto",
    "dropdown": "100",
    "header": "200",
    "modal": "300"
};
exports.default = layers;
